import React from 'react'

import IndexDefaultComponent, { formikValuesToApiConvertor, initialValues } from './indexDefaultComponent'

import { fetchAdv } from '../../store/adv/advSlice'
import { changeDefaultPageScrolledPagesAmountAndPosition } from '../../store/common/commonSlice'
import isEmpty from 'lodash/isEmpty'
import { fetchIndexContributions } from '../../store/contributions/contributionsSlice'
import '../app.sass'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/rootReducer'
import { ContributionType } from '../../store/contributions/contributionsTypings'

const Index = (): JSX.Element => {
    const list = useSelector<RootState, ContributionType[]>((state) => state.contributions.list)
    return (
        <>
            {/*@ts-ignore*/}
            {list.map((contribution, index) => {
                if (index < 10)
                    return <link rel="preload" as="image" href={contribution.thumbnail} key={contribution.id} />
            })}
            <IndexDefaultComponent />
        </>
    )
}

// @ts-ignore
Index.getInitialProps = async ({ store, req }) => {
    const {
        common: { scrolledPagesAmountAndPosition },
        contributions: { list }
    } = store.getState()
    if (isEmpty(list)) {
        if (req) {
            const page = req.query.p
            await store.dispatch(fetchIndexContributions(formikValuesToApiConvertor(initialValues, page || 1)))
        } else {
            await store.dispatch(fetchIndexContributions(formikValuesToApiConvertor(initialValues, 1)))
        }
    }
    if (scrolledPagesAmountAndPosition.sourcePage != 'indexScrolling')
        store.dispatch(changeDefaultPageScrolledPagesAmountAndPosition())
    await store.dispatch(fetchAdv())
}

export default Index
